export default class MissingTokenError extends Error {
  constructor() {
    super('Falha ao realizar o login, tente novamente.');
    this.name = 'MissingTokenError';
  }
}
